import { NgModule } from '@angular/core';
import { CanDeactivateGuard } from '../pzCore/can-deactivate-guard.service';

@NgModule({
    providers: [
        CanDeactivateGuard
    ]
})
export class AuthModule {
}
